import React from "react";
import { useSelector } from "react-redux";
import { FormHelperText, Stack, Box } from "@mui/material";
import WarningOutlinedIcon from "@mui/icons-material/WarningOutlined";
import { useQuoteContext } from "../../shared/contexts/QuoteContext";
import { RootState } from "../../store";

const ErrorMessage = ({ options }: { options: any }) => {
	const formik = options;

	const { isQuoteBound, isReferred, isDeclined } = useQuoteContext();
	const errors = useSelector((state: RootState) => state.errorSlice);

	const readonly = isQuoteBound || isReferred || isDeclined;

	const startDateError = formik.touched.startDate && formik.errors.startDate;
	const endDateError = formik.touched.endDate && formik.errors.endDate;

	const showDateError = !readonly && (Boolean(startDateError) || Boolean(endDateError));

	return (
		<>
			{(errors.isError || showDateError) && (
				<Box p="0.5em 1em" mb="1em" sx={{ backgroundColor: "rgba(220, 20, 60, 0.25)" }}>
					<Stack direction="row" alignItems={"center"}>
						<WarningOutlinedIcon
							color="error"
							sx={{ fontSize: "1.5em", mr: "0.25em" }}
						/>
						{showDateError ? (
							<FormHelperText error>
								{Boolean(startDateError) ? startDateError : endDateError}
							</FormHelperText>
						) : typeof errors.message === "string" ? (
							<FormHelperText hidden={!errors.isError} error={errors.isError}>
								{errors.message}
							</FormHelperText>
						) : (
							(errors.message ?? []).length > 1 &&
							errors.isError && (
								<ul>
									{errors.message.map((message: any) => (
										<li key={`message-${message}`}>{message}</li>
									))}
								</ul>
							)
						)}
					</Stack>
				</Box>
			)}
		</>
	);
};

export default ErrorMessage;
